import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';



@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class BasicWorkstationMasa extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;


  eletedFoot: BasicFoot = BasicFoot.type2;
  product: ProductDefinition;

  defHideObjects = [
    '_yyy',

  ];

  defShowObjects =  [
    'basic_workstation_masa_type_2',
    'xxx_basic_workstation_tabla_yyy',
  ];


  seletedFoot: BasicFoot = BasicFoot.type2;


  availableAnimations: AnimationDefinition[] = [];


  async created() {
    this.product = Store.getProductById('basic_workstation_masa');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes,['order'],['asc']);
    this.availableAnimations =  [];
    this.availableAnimationsChanged();
    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });
    if (Store.state.selection) {
      Store.state.selection.parts.forEach((element) => {
        this.colorChanged(element.color,element.palette,element.id);
      });
      await this.changeFoot(Store.state.selection.foot);
    } else {
      await  this.applyDefaultSelection();
    }

  }


  availableAnimationsChanged() {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }


  mounted() {
    // this.configuratorService = Store.state.configuratorService;

  }

  async applyDefaultSelection() {
    const selection = new BasicEtajerliMasaSelection();

    selection.parts = [];
    selection.foot = BasicFoot.type2;

    this.product.defaults.parts.forEach((element) => {
      this.colorChanged(element.color,element.palette,element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.name = element.name;
      part.palette = element.palette;
      selection.parts.push(part);
    });
    Store.state.selection = selection;

  }
  async changeFoot(foot:BasicFoot) {

    if (foot === BasicFoot.type2) {
      await this._configuratorService.hideObjects({ objects: ['type'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['basic_workstation_masa_type_2'], operator: FilterOperators.Contains });
      Store.state.selection.foot = BasicFoot.type2;
      this.seletedFoot = BasicFoot.type2;
    }
    if (foot === BasicFoot.type3) {
      await this._configuratorService.hideObjects({ objects: ['type'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['basic_workstation_masa_type_3'], operator: FilterOperators.Contains });
      Store.state.selection.foot = BasicFoot.type3;
      this.seletedFoot = BasicFoot.type3;
    }
  }

  async colorChanged(color: any,palette: any,part: any) {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    if (part === 'basic_workstation_separator') {

      if (palette === 'pleksi') {
        await this._configuratorService.hideObjects({ objects: ['basic_workstation_melamin_separator_yyy'], operator: FilterOperators.Contains });
        await this._configuratorService.showObjects({ objects:  ['basic_workstation_plexi_separator_yyy'], operator: FilterOperators.Contains });
      } else {

        await this._configuratorService.showObjects({ objects: ['basic_workstation_melamin_separator_yyy'], operator: FilterOperators.Contains });
        await this._configuratorService.hideObjects({ objects:  ['basic_workstation_plexi_separator_yyy'], operator: FilterOperators.Contains });
      }

    }
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

}

export class BasicEtajerliMasaSelection {
  foot: BasicFoot;
  parts: PartSelection[];
}

export class PartSelection {
  id: string;
  palette: string;
  name: string;
  color: string;

}


enum BasicFoot {
  type1 = 'type1',
  type2 = 'type2',
  type3 = 'type3',
}



// WEBPACK FOOTER //
// ./src/components/families/basic/BasicWorkstationMasa.ts